export const SOP_AI_ASSIST_EVENT = 'sop-ai-assist'

export interface IncidentContextI {
  facility_id: string
  facility_name: string
  floor_name: string
  device_type: string
  device_name: string
  incident_id: string
  incident_type: string
  display_id: string
}

export interface SourceI {
  content: string
  score: number
}

export const ChatActor = {
  USER: 'user',
  BOT: 'bot',
} as const

export type ChatActorType = (typeof ChatActor)[keyof typeof ChatActor]

export interface ChatMessageI {
  id: string
  text: string
  actor: ChatActorType
  sources?: SourceI[]
  suggestedQuestions?: string[]
  timestamp: Date
}
